import { IQueryContext } from 'framework/context/IQueryContext';
import { IQueryResultWithMetadata, ITender, ITendersQueryMetadata, ITendersQueryParams } from 'gen/ApiClient';
import React from 'react';

export const TendersListQueryContext = React.createContext<IQueryContext<IQueryResultWithMetadata<ITender, ITendersQueryMetadata>, ITendersQueryParams>>(
	undefined as any
);
